module.exports = __webpack_public_path__ + "img/70.8e48e0d3.jpg";